/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardStats } from '../models/DashboardStats';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class DashboardService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Kennzahlen für die Startseite
   * Liefert systemweite Kontakt- und Anrufzahlen unabhängig vom Mandanten des Benutzers. Heute bezieht sich auf Europe/Berlin.
   * @returns DashboardStats Aktuelle Kennzahlen
   * @throws ApiError
   */
  public getDashboardStats(): CancelablePromise<DashboardStats> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v1/dashboard/stats',
      errors: {
        403: `Kein Zugriff`,
      },
    });
  }

}
